export const columns = function () {
    return [
		{
		  prop: "name",
		  label: "附加服务",
		  minWidth: 30,
		},
        {
          prop: "amount",
          label: "服务额（元）",
          minWidth: 30,
        },
        {
          prop: "amountFee",
          label: "应交服务费",
          minWidth: 50,
        },
        {
          prop: "handle",
          label: "操作",
          minWidth: 50,
        },

    ]
}

// 搜索
export const searchFormOption = function() {
  return [
	   {
		 prop: "id",
		 label: "主服务",
		 type: "select",
		 placeholder: "请选择主服务类型",
		 width: "20%",
		 options: this.detailType
	   }
  ]
}

// 表单相关
export const formOption = function() {
  return [
	   {
		 prop: "pid",
		 label: "主服务",
		 type: "select",
		 placeholder: "请选择",
		 width: "20%",
		 options: this.detailType
	   },
	   {
		 prop: "name",
		 label: "附加服务",
		 type: "input",
		 width: "20%",
	   },
	   {
		 prop: "amount",
		 label: "服务额",
		 type: "input",
		 placeholder: 0,
		 width: "20%",
		 templateNote:'元'
	   },
		{
		 prop: "amountFee",
		 label: "应交服务费",
		 type: "input",
		 placeholder: 0,
		 width: "20%",
		 templateNote:'元'
	   },
  ]
}

/**
 * 校验相关 
 */
export const rules = function(self) {
  return {
    pid: [
      { required: true, message: '请选择主服务', trigger: ['change', 'blur']}
    ],
	name: [
	  { required: true, message: '请填写附加服务', trigger: ['blur']}
	],
  }
}

export default {}